import { Filter } from "@/shared/lib/filter/filter";
import { Lst } from "@/shared/lib/lst/lst";
import { OrdrBy } from "@/shared/lib/ordr/ordrBy";
import {
  PestGroupSnapshot,
  PestSnapshot,
} from "@/services/backend/pestcontrol/types/pest";

export enum PestcontrolMonitorType {
  Checkpoint = "CHECKPOINT",
  FlyExterminator = "FLY_EXTERMINATOR",
  IoT = "IOT_MONITOR",
}

export type PestcontrolMonitorDetails = {
  description: string;
  installationType: string;
  heightMm: number;
  widthMm: number;
  depthMm: number;
  weightG: number;
  coverageValue: number;
  coveragePreText: string;
  coveragePostText: string;
  starterSpecification: string;
  protectionLevel: string;
};

export type PestcontrolMonitor = {
  id: string;
  companyId: string;
  key: string;
  name: string;
  supplier: string;
  type: PestcontrolMonitorType;
  times: {
    install: number;
    maintain: number;
  };
  capabilities: {
    permanentBaiting: boolean;
    hasLethalAgent: boolean;
    checkpointVisual: boolean;
  };
  buyPrice: number;
  image?: {
    fileId: string;
    prefix: string;
    addedAt: string;
  };
  recommendedVisits: number;
  details: PestcontrolMonitorDetails;
  pests: PestSnapshot[];
  groups: PestGroupSnapshot[];
  createdAt?: string;
  updatedAt?: string;
};

export type PutPestcontrolMonitorRequest = {
  companyId: string;
  monitor: PestcontrolMonitor;
  pestIds: string[];
  groupIds: string[];
};

export type ShowPestcontrolMonitorRequest = {
  id: string;
};

export type DeletePestcontrolMonitorRequest = {
  id: string;
};

export type UploadPestcontrolMonitorImageRequest = {
  monitorId: string;
  fileId: string;
  file: File | null;
};

export type DeletePestcontrolMonitorImageRequest = {
  monitorId: string;
};

export type ShowPestcontrolMonitorImageRequest = {
  monitorId: string;
  fileId: string;
  filePrefix: string;
};

export type PestcontrolMonitorOrderBy =
  "name" | "type" | "supplier" | "createdAt" | "updatedAt";

export type PestcontrolMonitorListRequest = {
  company?: Filter<string>;
  type?: Filter<PestcontrolMonitorType>;
  name?: Filter<string>;
  supplier?: Filter<string>;
  orderBy?: OrdrBy<PestcontrolMonitorOrderBy>[];
  limit?: number;
  offset?: number;
};

export type PestcontrolMonitorListResponse = Lst<PestcontrolMonitor>;
